import { Image } from '@cian/ui-kit';
import { IconActionProfile24 } from '@cian/ui-kit-design-tokens/icons';
import * as React from 'react';

import * as styles from './styles.css';
import { IconAgent24 } from '../../Icons/IconAgent24';

export enum EUserCardAvatarType {
  Agent = 'agent',
  User = 'user',
}

type TUserCardAvatar = {
  src?: string | null;
  type: EUserCardAvatarType;
};

export const UserCardAvatar: React.FC<TUserCardAvatar> = ({ src, type }) => {
  return (
    <div className={styles['container']} data-testid="UserCardAvatar">
      {src ? (
        <div className={styles['image']}>
          <Image
            src={src}
            alt="Фотография пользователя"
            borderRadius={'50%'}
            objectFit="contain"
            theme="light"
            height={80}
            width={80}
            preloader
          />
        </div>
      ) : (
        <div className={styles['icon']}>
          <span data-testid={`IconAvatar${type === 'agent' ? 'Agent' : 'User'}`}>
            {type === 'agent' ? <IconAgent24 /> : <IconActionProfile24 color="current_color" />}
          </span>
        </div>
      )}
    </div>
  );
};
